"use strict";
var ɵngcc0 = require('@angular/core');

var _c0 = ["*"];
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var OwlChild = (function () {
    function OwlChild(el) {
        this.el = el;
        this.owlClass = true;
        this.options = {};
        $ = $ || jQuery;
    }
    OwlChild.prototype.ngAfterViewInit = function () {
        this.$owl = $(this.el.nativeElement).owlCarousel(this.options);
    };
    OwlChild.prototype.trigger = function (action, options) {
        this.$owl.trigger(action, options);
    };
    OwlChild.prototype.ngOnDestroy = function () {
        this.$owl.trigger('destroy.owl.carousel').removeClass('owl-loaded');
        delete this.$owl;
    };
    __decorate([
        core_1.HostBinding('class.owl-carousel'), 
        __metadata('design:type', Object)
    ], OwlChild.prototype, "owlClass", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], OwlChild.prototype, "options", void 0);
    OwlChild = __decorate([ __metadata('design:paramtypes', [core_1.ElementRef])
    ], OwlChild);
OwlChild.ɵfac = function OwlChild_Factory(t) { return new (t || OwlChild)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OwlChild.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OwlChild, selectors: [["owl-carousel-child"]], hostVars: 2, hostBindings: function OwlChild_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("owl-carousel", ctx.owlClass);
    } }, inputs: { options: "options" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OwlChild_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OwlChild, [{
        type: core_1.Component,
        args: [{
                selector: 'owl-carousel-child',
                template: '<ng-content></ng-content>'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { owlClass: [{
            type: core_1.HostBinding,
            args: ['class.owl-carousel']
        }], options: [{
            type: core_1.Input
        }] }); })();
    return OwlChild;
}());
exports.OwlChild = OwlChild;

//# sourceMappingURL=owl-child.component.js.map